export default "__VITE_ASSET__Td4BfUWV__"